const theodenConfig = {
  url : process.env.REACT_APP_THEODEN_API
}

export default theodenConfig